module.exports = "/lucky-balls/img/weager/balls/color/green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/green.png
// module id = 1179
// module chunks = 0